"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postQuestionResponseVersionUrl = exports.postQuestionResponse = exports.getQuestions = exports.getQuestion = exports.getCampaign = exports.CampaignStatus = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _axiosRetry = _interopRequireDefault(require("axios-retry"));

var _axiosRetryPolicy = require("./axiosRetryPolicy");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const getQuestionCacheKey = (accessToken, baseUrl, campaignId, questionId) => `${accessToken}_${baseUrl}_${campaignId}_${questionId}`;

const questionRequestCache = {};

const getCampaignCacheKey = (accessToken, baseUrl, campaignId) => `${accessToken}_${baseUrl}_${campaignId}`;

const campaignRequestCache = {};
let CampaignStatus;
exports.CampaignStatus = CampaignStatus;

(function (CampaignStatus) {
  CampaignStatus["Auto"] = "Auto";
  CampaignStatus["Suspended"] = "Suspended";
})(CampaignStatus || (exports.CampaignStatus = CampaignStatus = {}));

const getCampaign = (baseUrl, useCache, accessToken, campaignId) => {
  if (useCache) {
    const cachedCampaignRequest = campaignRequestCache[getCampaignCacheKey(accessToken, baseUrl, campaignId)];

    if (cachedCampaignRequest) {
      return cachedCampaignRequest;
    }
  }

  const url = `/v1/campaigns/${campaignId}`;

  const client = _axios.default.create();

  (0, _axiosRetry.default)(client, _axiosRetryPolicy.standardRetryPolicy);
  const promise = client.get(url, {
    baseURL: baseUrl,
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  }).then(response => response.data).catch(err => {
    delete campaignRequestCache[getCampaignCacheKey(accessToken, baseUrl, campaignId)];
    throw err;
  });
  campaignRequestCache[getCampaignCacheKey(accessToken, baseUrl, campaignId)] = promise;
  return promise;
};

exports.getCampaign = getCampaign;

const getQuestion = (baseUrl, useCache, accessToken, campaignId, questionId) => {
  if (useCache) {
    const cachedQuestionRequest = questionRequestCache[getQuestionCacheKey(accessToken, baseUrl, campaignId, questionId)];

    if (cachedQuestionRequest) {
      return cachedQuestionRequest;
    }
  }

  const url = `/v1/campaigns/${campaignId}/questions/${questionId}`;

  const client = _axios.default.create();

  (0, _axiosRetry.default)(client, _axiosRetryPolicy.standardRetryPolicy);
  const promise = client.get(url, {
    baseURL: baseUrl,
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  }).then(response => response.data).catch(err => {
    delete questionRequestCache[getQuestionCacheKey(accessToken, baseUrl, campaignId, questionId)];
    throw err;
  });
  questionRequestCache[getQuestionCacheKey(accessToken, baseUrl, campaignId, questionId)] = promise;
  return promise;
};

exports.getQuestion = getQuestion;

const getQuestions = (baseUrl, accessToken, campaignId) => {
  const url = `/v1/campaigns/${campaignId}/questions`;

  const client = _axios.default.create();

  (0, _axiosRetry.default)(client, _axiosRetryPolicy.standardRetryPolicy);
  return client.get(url, {
    baseURL: baseUrl,
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  }).then(response => response.data._embedded.question);
};

exports.getQuestions = getQuestions;

const postQuestionResponse = (baseUrl, accessToken, campaignId, questionId, version, questionResponse) => {
  const url = `/v1/campaigns/${campaignId}/questions/${questionId}/versions/${version}`;

  const client = _axios.default.create();

  (0, _axiosRetry.default)(client, _axiosRetryPolicy.standardRetryPolicy);
  return client.post(url, questionResponse, {
    baseURL: baseUrl,
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  }).then(response => response.data);
};

exports.postQuestionResponse = postQuestionResponse;

const postQuestionResponseVersionUrl = (baseUrl, accessToken, versionUrl, questionResponse) => {
  const client = _axios.default.create();

  (0, _axiosRetry.default)(client, _axiosRetryPolicy.standardRetryPolicy);
  return client.post(versionUrl, questionResponse, {
    baseURL: baseUrl,
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  }).then(response => response.data);
};

exports.postQuestionResponseVersionUrl = postQuestionResponseVersionUrl;